import { render, staticRenderFns } from "./SupplementRecordTimeline.vue?vue&type=template&id=64c5167a&scoped=true&"
import script from "./SupplementRecordTimeline.vue?vue&type=script&lang=js&"
export * from "./SupplementRecordTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SupplementRecordTimeline.vue?vue&type=style&index=0&id=64c5167a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5167a",
  null
  
)

export default component.exports